import { render } from "./PronounFilter.vue?vue&type=template&id=751fab48"
import script from "./PronounFilter.vue?vue&type=script&lang=js"
export * from "./PronounFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__